module.exports = __webpack_public_path__ + "96b3b67f14a691521f8c73e6c87d6f09.png";